export default __webpack_public_path__ + "static/media/office-ad.779fd7ae.jpg";